export default __webpack_public_path__ + "static/media/banner-ub-1.bead2e93.jpg";